import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=1c0d6030&scoped=true&"
import script from "./UserCard.vue?vue&type=script&lang=ts&"
export * from "./UserCard.vue?vue&type=script&lang=ts&"
import style0 from "./UserCard.vue?vue&type=style&index=0&id=1c0d6030&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0d6030",
  null
  
)

export default component.exports